import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/occupations';
import { dateToggled } from './utils';

export default function* listenDateToggled() {
  yield takeEvery(actionTypes.dateToggled.toString(), dateToggled);
}
